import { render, staticRenderFns } from "./OverviewDrawer.vue?vue&type=template&id=3b48ee0c&scoped=true&"
import script from "./OverviewDrawer.vue?vue&type=script&lang=js&"
export * from "./OverviewDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OverviewDrawer.vue?vue&type=style&index=0&id=3b48ee0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48ee0c",
  null
  
)

export default component.exports